import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div``

export const PhotosAndInformation = styled.div`
  ${tw`grid grid-cols-1 gap-y-16 mb-insetY`};
  grid-template-areas: 'photos' 'information';

  max-width: var(--screen-max);
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 768px) {
    ${tw`grid grid-cols-2 px-insetX`};
    grid-template-areas: 'photos information';
  }

  @media (min-width: 1024px) {
    grid-template-columns: 62% 38%;
  }
`

export const Title = styled.div`
  text-align: center;
`

export const Options = styled.div`
  ${tw`mb-12 grid gap-6`};
`

export const Photos = styled.div`
  grid-area: photos;
`

export const Information = styled.div`
  ${tw`relative px-insetX`};
  grid-area: information;
  max-width: 36rem;
  justify-self: center;

  @media (min-width: 768px) {
    ${tw`pt-insetY px-0 pl-16`};
  }

  /* &::before {
    content: '';
    ${tw`absolute top-0 left-0 w-px h-full`};
    background-color: var(--color-grey);
  } */
`

export const Artisan = styled.div`
  ${tw`mb-1`};
`

export const ProductTitle = styled.div`
  ${tw`mb-6`};
`

export const Price = styled.div`
  ${tw`mb-8`};
`

export const Sku = styled.div`
  text-align: center;
  color: var(--color-blue-grey);
`

export const SizeGuideAndDetailsWrapper = styled.div`
  ${tw`px-insetX py-insetY ta-max-width-parent`};
  color: var(--color-gold-black);
  background-color: var(--color-gold-white);
  border-width: 1px 0;
  border-color: var(--color-gold-white-line);
`

export const SizeGuideAndDetails = styled.div`
  ${tw`grid grid-cols-1 gap-y-8`};

  @media (min-width: 768px) {
    ${tw`grid grid-cols-2 gap-x-16`};
  }

  @media (min-width: 1024px) {
    grid-template-columns: 62% 38%;
  }
`

export const SizeGuideAndDetailsHeader = styled.div`
  ${tw`mb-4`};
`

export const SizeGuide = styled.div``

export const SizeGuideTable = styled.div`
  ${tw`overflow-x-auto`};

  table {
    ${tw`w-full mt-4`};
    /* Override inline style */
    border: none !important;
    border-spacing: 0 !important;
  }

  table tbody {
    white-space: nowrap;
  }

  table.inverse-fix tbody {
    ${tw`flex justify-between`};
  }

  table tr:first-child th:first-child {
    ${tw`text-left`};
  }

  table th {
    ${tw`align-bottom`};
  }

  table th,
  table td {
    ${tw`p-1 text-right`};
  }

  table.inverse-fix th,
  table.inverse-fix td {
    ${tw`block`};
  }

  table td:first-child,
  table tr:first-child td {
    ${tw`font-bold text-left`};
  }

  table thead + tbody > tr:first-child > td {
    ${tw`font-normal text-right`};
  }

  table thead + tbody > tr:first-child > td:first-child {
    ${tw`font-bold text-left`};
  }

  table.inverse-fix tr:first-child td {
    ${tw`text-left`};
  }

  table.inverse-fix td:first-child {
    ${tw`text-right`};
  }
`

export const Details = styled.div``
